import { render, staticRenderFns } from "./Coment.vue?vue&type=template&id=6bd26830&"
import script from "./Coment.vue?vue&type=script&lang=js&"
export * from "./Coment.vue?vue&type=script&lang=js&"
import style0 from "./Coment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports